import { createContext, useContext } from 'react';

/**
 * A topbar está estreita? Quem vai dentro dela pergunta aqui.
 *
 * No celular a topbar tem 264–319 px para o caminho da página, a busca, a
 * clínica, a pílula do atendimento, o sino e a conta. O rótulo "Em andamento" e
 * o seletor de unidade com 180 px empurravam o avatar para 211 px fora da tela.
 * Compacta, cada ação vira ícone com o nome no `aria-label` — quem ouve continua
 * recebendo o nome inteiro, quem vê recebe o que cabe.
 *
 * Contexto, e não prop: as ações chegam à topbar como `ReactNode` já montado
 * pelo shell, e só a topbar sabe a própria largura.
 */
export const TopbarCompactaContexto = createContext(false);

export function useTopbarCompacta(): boolean {
    return useContext(TopbarCompactaContexto);
}
